<template>
  <div class="device-replay-search-wrap">
    <el-form ref="form" :model="model" :inline="true" :rules="rules">
      <el-form-item :label="'回放速度' | translateTo(i18nPath)" prop="speed">
        <el-select v-model="model.speed">
          <el-option label="1x" :value="1" />
          <el-option label="1.5x" :value="1.5" />
          <el-option label="2x" :value="2" />
          <el-option label="5x" :value="5" />
          <el-option label="10x" :value="10" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="validateEvent" :loading="loading">
          {{ $t('回放') }}
        </el-button>
        <el-button type="primary" @click="locateTo">
          {{ $t('定位') }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
      default: () => ({})
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    i18nPath: {
      type: String,
      default: ''
    }
  },
  methods: {
    validateEvent() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$emit('replay', this.model);
        } else {
          return false;
        }
      });
    },
    locateTo() {
      this.$emit('locateTo');
    }
  }
};
</script>

<style lang="scss">
.device-replay-search-wrap {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;

  width: 100%;

  box-sizing: border-box;

  padding: 15px 20px 0;
  background: linear-gradient(to bottom, rgba(7, 18, 33, 0.9), transparent);
}
</style>
